import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import Device from "@/model/Device";
import DeviceStorage from "@/storage/DeviceStorage";
import ActiveModule from './ActiveModule';
import {Container} from "typescript-ioc";

export abstract class DeviceModule implements ActiveModule<Device> {

    abstract active: Device;

    abstract activeOrNull: Device | null;

    abstract activate(t: Device): Promise<void>;

    abstract hasActive(): Promise<boolean>;

    abstract inactivate(): Promise<void>;

    abstract destroy(): Promise<void>;
}

@Module({dynamic: true, namespaced: true, store, name: 'device'})
class DeviceModuleImpl extends VuexModule implements DeviceModule {

    private storage = Container.get(DeviceStorage)

    activeOrNull = this.storage.getOrNull()

    get active(): Device {
        return this.activeOrNull ?? new Device()
    }

    @Action
    async activate(t: Device): Promise<void> {
        this.set(t)
        this.storage.set(t)
    }

    @Action
    async inactivate(): Promise<void> {
        this.remove()
        this.storage.remove()
    }

    @Action
    async hasActive(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Mutation
    private set(t: Device) {
        this.activeOrNull = t
    }

    @Mutation
    private remove() {
        this.activeOrNull = null
    }

    @Action
    async destroy(): Promise<void> {
        this.inactivate()
    }
}

const deviceModule: DeviceModule = getModule(DeviceModuleImpl)
export default deviceModule
